import { createBrowserHistory as createHistory } from "history";
// import createHistory from "history/createBrowserHistory";
export default createHistory();
